<template>
  <modal @before-open="beforeOpen" @opened="opened" name="courseTableModal" :draggable="'.header'" :reset="true"
         :classes="['courseTableModal','generalbox']" :adaptive="true"
          :height="'80%'" :width="'80%'" :max-width="1540" :max-height="885" :min-width="1092"
         :min-height="614" :click-to-close="false" :pivotX="pivotX" :pivotY="pivotY">
    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2>课表</h2>
    </div>
    <div class="content">
      <course-table :coursePayload="courseInfo"></course-table>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';

  import courseTable from 'components/course/courseTable'

  export default {
    name: "courseTableModal",
    data() {
      return {
        courseInfo: {},
        pivotX: null,
        pivotY: null
      }
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.$modal.hide("courseTableModal");
      },
      beforeOpen(data) {
        this.courseInfo = data.params

        if (this.courseInfo.stackLayout) {
          this.pivotX = this.modalOffsetDistance.x
          this.pivotY = this.modalOffsetDistance.y
        } else {
          this.pivotX = 0.5
          this.pivotY = 0.5
        }
      },
      opened() {
        this.updateModalZIndex(this.$el)
      },
      
    },
    computed: {
      ...mapState(['modalOffsetDistance']),
    },
    mounted() {
    },
    components: {courseTable}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
</style>


// WEBPACK FOOTER //
// src/components/course/courseTableModal.vue